import * as React from 'react';
import AppConfig, { AppConfigInterface } from 'config/appConfig';

const AppConfigContext = React.createContext(AppConfig);
const useAppConfig = (): AppConfigInterface => React.useContext(AppConfigContext);

export { AppConfigContext as default, useAppConfig };
